import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { MonthlyOrderingBudget, MonthlySalesTarget } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0240. チーム月間発注予算一覧
 * [GET] /workspaces/:identifier/teams/:team_id/monthly_ordering_budgets
 */
type Props = {
  identifier: string;
  team_id: number;
};

type MonthlyOrderingBudgetsResponse = {
  previous_ordering_budgets: MonthlyOrderingBudget[];
  current_ordering_budgets: MonthlyOrderingBudget[];
  next_ordering_budgets: MonthlyOrderingBudget[];
};

const monthlyOrderingBudgets = (props: Props): Promise<MonthlyOrderingBudgetsResponse> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/monthly_ordering_budgets`, {
    params: props,
  });
};

export const useMonthlyOrderingBudgets = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'teams', props.team_id, 'monthly_ordering_budgets'],
    queryFn: () => monthlyOrderingBudgets(props),
  });
};

export const useInvalidateMonthlyOrderingBudgets = (props: Props) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({
      queryKey: ['workspaces', props.identifier, 'teams', props.team_id, 'monthly_ordering_budgets'],
    });
  };

  return { invalidate };
};
